module.exports = __webpack_public_path__ + "img/17.6ed78ff5.png";